jQuery(document).ready(function ($) {
	/**
	 * Show or hide review comment.
	 */
	$(document).on("click", ".toggle-comment", function (e) {
		e.preventDefault();

		var $this = $(this);
		var $reviewComment = $this.closest(".gs-review-item").find(".gs-review-comment");
		var $fullComment = $reviewComment.find(".full-comment");
		var $shortComment = $reviewComment.find(".short-comment");

		$shortComment.toggle();
		$fullComment.toggle();

		if ($fullComment.is(":visible")) {
			$this.html('<span class="dashicons dashicons-minus"></span> Lire moins');
		} else {
			$this.html('<span class="dashicons dashicons-plus"></span> Lire plus');
		}
	});

	/**
	 * Show or hide review response.
	 */
	$(document).on("click", ".toggle-responses", function (e) {
		e.preventDefault();

		var $this = $(this);
		var $responses = $this.closest(".gs-review-item").find(".gs-review-responses");

		$responses.slideToggle(400, function () {
			if ($responses.is(":visible")) {
				$this.html('<span class="dashicons dashicons-hidden"></span> Masquer la réponse');
			} else {
				$this.html('<span class="dashicons dashicons-visibility"></span> Voir la réponse');
			}
		});
	});
});